import { useEffect, useState } from "react";

export function useInterceptor() {
  const [error, setError] = useState<string>("");

  useEffect(() => {
    let origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.send = function (
      ...args: [body?: Document | XMLHttpRequestBodyInit | null | undefined]
    ) {
      const body = args?.toString();
      const matchesForm =
        body?.includes("request_type=RESPONSE") &&
        body?.includes("signInName=") &&
        body?.includes("password=");

      this.addEventListener("load", function () {
        if (
          this.status === 400 &&
          this.responseText === "Bad Request" &&
          matchesForm === true
        ) {
          setError(
            "A current authenticated session is preventing you from logging in. Please log out of any existing sessions. If the problem persists, clear all cache including logins and refresh the page."
          );
        }
      });

      origSend.apply(this, args);
    };

    return () => {
      XMLHttpRequest.prototype.send = origSend;
    };
  }, []);

  return error;
}
